import React from 'react'
import { Checkbox } from 'semantic-ui-react'

class Switch extends React.Component {

    checkField = null

    render() {
        return <Checkbox
            label={this.props.label}
            toggle        
            checked={this.props.value}    
            ref={(c) => this.checkField = c}
            onChange={(e,t) => this.onChangeCheck(this.props.name, t.checked)}
        />
    }
    onChangeCheck = (name, value) => {

        if (this.props.onChangeCheck)
            this.props.onChangeCheck(name, value)
    }
}

export default Switch


// WEBPACK FOOTER //
// ./src/components/Eventos/Pesquisa/Switch.js